import SettingsPage from "../components/SettingsPane/SettingsPage";
import { CheckboxFieldSettings } from "../SettingsScreen";
import { itx } from "../translationItx/itx";

export default function SettingPageNavigator(props: {
  handler: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { setRefresh, refresh } = props;
  return (
    <SettingsPage
      handler="/settings/navigator" // no itx
    >
      <fieldset className="form-group">
        <CheckboxFieldSettings
          name="showMenuButtonTooltips" // no itx
          label={itx("SettingsScreen.showTooltips", "Tooltips anzeigen")}
          setRefresh={setRefresh}
          refresh={refresh}
        />
        <CheckboxFieldSettings
          name="useNavigatorBreakLines"
          label={itx("SettingsScreen.useNavigatorBreakLines", "Abrisslinien verwenden")}
          setRefresh={setRefresh}
          refresh={refresh}
        />
        <CheckboxFieldSettings
          name="openWithOneClick" // no itx
          label={itx("SettingsScreen.openWithOneClick", "Zeichungen und Eigenschaft mit einem Klick öffen")}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      </fieldset>
    </SettingsPage>
  );
}
